module.exports = __webpack_public_path__ + "static/media/lavabos.1e3331dc.svg";